import {useLocalization} from '@/hooks/useLocalization';
import BotMessage from '@/components/ChatMessage/BotMessage';
import styles from '@/styles/chat.module.scss';

const HeroCheckIcon = () => (
    <svg viewBox="0 0 24 24">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
    </svg>
);

const ConfirmCheckIcon = () => (
    <svg viewBox="0 0 24 24">
        <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
    </svg>
);

export default function OfflineScreen() {
    const {t} = useLocalization();

    return (
        <div>
            <div className={styles.offline}>
                <div className={styles.offlineHero}>
                    <HeroCheckIcon/>
                </div>
                <div className={styles.offlineConfirm}>
                    <div className={styles.offlineConfirmText}>{t('offline.confirm')}</div>
                </div>
                <p className={styles.offlineMessage}>{t('offline.message')}</p>
            </div>
        </div>
    );
}
